import emailjs from "@emailjs/browser";

export async function sendEmail(email, message) {
  emailjs.init("srg1PWI8rZFlqZa21");
  const serviceId = "service_airn8gh";
  const templateId = "template_1rqi7xc";
  try {
    await emailjs.send(serviceId, templateId, {
      recipient: email,
      message: message,
    });
    return true;
  } catch (error) {
    console.error("sendEmail", error);
    return false;
  }
}
